import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import DateField from 'ui-library/inputs/DateField';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';
import PaddedBorderedCell from 'ui-library/internal/PaddedBorderedCell';

const INPUT_CLASSES = [TextField, DateField];

const FieldInputGuidelines = (): JSX.Element => (
  <div className="u-padding">
    <h1>Field Inputs</h1>
    <a href="https://zpl.io/1VUxqv">Zeplin mocks</a>
    <div className="u-large-spacing-top">
      <div className="u-small-spacing-bottom">Field Inputs can take the following sizes and forms:</div>
      <table>
        <tbody>
          <tr>
            <PaddedBorderedCell />
            <PaddedBorderedCell>
              <code>Text</code>
            </PaddedBorderedCell>
            <PaddedBorderedCell>
              <code>DateField</code>
            </PaddedBorderedCell>
          </tr>
          <tr>
            <PaddedBorderedCell>Field only</PaddedBorderedCell>
            {INPUT_CLASSES.map((InputClass) => (
              <PaddedBorderedCell>
                <InputClass
                  placeholder="Watermark"
                  label="Label"
                  labelStyle={FieldLabel.STYLES.HIDDEN}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </PaddedBorderedCell>
            ))}
          </tr>
          <tr>
            <PaddedBorderedCell>Field with label</PaddedBorderedCell>
            {INPUT_CLASSES.map((InputClass) => (
              <PaddedBorderedCell>
                <InputClass
                  placeholder="Watermark"
                  label="Label"
                  labelStyle={FieldLabel.STYLES.LABEL}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </PaddedBorderedCell>
            ))}
          </tr>
          <tr>
            <PaddedBorderedCell>Required field</PaddedBorderedCell>
            {INPUT_CLASSES.map((InputClass) => (
              <PaddedBorderedCell>
                <InputClass
                  placeholder="Watermark"
                  label="Required"
                  labelStyle={FieldLabel.STYLES.LABEL}
                  isRequired={true}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </PaddedBorderedCell>
            ))}
          </tr>
          <tr>
            <PaddedBorderedCell>Field with sublabel</PaddedBorderedCell>
            {INPUT_CLASSES.map((InputClass) => (
              <PaddedBorderedCell>
                <InputClass
                  placeholder="Watermark"
                  label="Sublabel"
                  labelStyle={FieldLabel.STYLES.SUBLABEL}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </PaddedBorderedCell>
            ))}
          </tr>
          <tr>
            <PaddedBorderedCell>Field with description</PaddedBorderedCell>
            {INPUT_CLASSES.map((InputClass) => (
              <PaddedBorderedCell>
                <InputClass
                  placeholder="Watermark"
                  label="Label"
                  labelStyle={FieldLabel.STYLES.LABEL}
                  description="Description goes here"
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </PaddedBorderedCell>
            ))}
          </tr>
          <tr>
            <PaddedBorderedCell>Field with secondary button</PaddedBorderedCell>
            {INPUT_CLASSES.map((InputClass) => (
              <PaddedBorderedCell>
                <InputClass
                  placeholder="Watermark"
                  label="Label"
                  labelStyle={FieldLabel.STYLES.LABEL}
                  button={<Button buttonStyle={ButtonStyle.SECONDARY} size={ButtonSize.SMALL} text="CTA" />}
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </PaddedBorderedCell>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default FieldInputGuidelines;
